export default {
  mounted() {
    this.el.addEventListener("click", (e) => {
      const th = e.target.closest("[data-sort-col]")
      if (th) {
        e.preventDefault()
        e.stopPropagation()
        this.pushEventTo(this.el, "sort_column", {
          col: th.dataset.sortCol,
          shift: e.shiftKey.toString()
        })
      }
    })
  }
}
